import * as Sentry from '@sentry/browser';
import { styled } from '@/configs/stitches.config';
import { useClient } from '@/hooks';
import { useMscPipeline } from '@/services/pre-enrollment';
import { StatesEnum } from '@/utils';

const Root = styled('div', {
  fontSize: '14px',
  marginRight: '$spacingMd',
});

const ChangePaymentMethodLink = styled('a', {
  color: '$textColorInteractionPrimaryActive',
});

const Title = styled('p', {
  color: '#862E9C',
  font: '$headingSmBold',
  marginBottom: '$spacingMd',
});

const Question = styled('p', {
  fontWeight: 'bold',
});

const Answer = styled('p', {
  paddingBottom: '$spacingMd',
});

const FaqCard: React.FC = () => {
  const { changeMscPipeline } = useMscPipeline();
  const { clientId, mscPipelineId, selectionProcessId } = useClient();

  const handleChangePaymentMethod = async (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    event.preventDefault();
    try {
      await changeMscPipeline({
        mscPipelineId,
        selectionProcessId,
        event: StatesEnum.CHANGE_PAYMENT_METHOD,
      });

      window.location.href = process.env.REACT_APP_EDUCATION_URL;
    } catch (error) {
      Sentry.setUser({ id: clientId });
      Sentry.captureException(error);
    }
  };

  return (
    <Root className="keen-slider__slide">
      <div className="carousel-card">
        <Title>Dúvidas frequentes</Title>
        <Question>Quero desistir do financiamento. Como faço? </Question>
        <Answer>
          Você tem flexibilidade para desistir do financiamento e escolher outro
          método de pagamento disponível clicando{' '}
          <ChangePaymentMethodLink href="#" onClick={handleChangePaymentMethod}>
            aqui
          </ChangePaymentMethodLink>
          .
        </Answer>
        <Question>
          Não fui aprovado na análise de crédito, ainda posso estudar na Trybe?
        </Question>
        <Answer>
          Sim. Mesmo se você não for aprovado na análise de crédito, existem
          outros métodos de pagamento disponíveis para você estudar na Trybe.
        </Answer>
      </div>
    </Root>
  );
};

export default FaqCard;
